/**
 * Trae la marca del ticket de la empresa y el contacto de la tienda activas al iniciar sesión y al
 * cambiar de tienda o empresa. Sólo lee; sin red conserva la copia anterior.
 */
import { useEffect } from 'react'
import { useCajeroStore } from '@features/auth/hooks/useAuth'
import { sincronizarMarca } from './marcaTicket'

export function useMarcaTicketSync() {
  const businessId = useCajeroStore(s => s.cajero?.activeBusinessId ?? s.cajero?.businessId ?? null)
  const storeId = useCajeroStore(s => s.cajero?.activeStoreId ?? s.cajero?.storeId ?? null)
  useEffect(() => {
    if (businessId) void sincronizarMarca(businessId, storeId).catch(() => {})
  }, [businessId, storeId])
}
